export const ROUTER_BASENAME: string = (() => {
  if (typeof window === 'undefined') return '';
  const path = window.location.pathname;
  if (path === '/admin-app' || path.startsWith('/admin-app/')) return '/admin-app';
  return '';
})();
